export default "__VITE_ASSET__NWwGO2pA__"